import {
  EditOutlined,
  ExportOutlined,
  EyeOutlined,
  MoreOutlined,
  UploadOutlined,
  LoadingOutlined
} from "@ant-design/icons";
import { Affix, Button, Card, Dropdown, Menu, message, Space, Col, Form, Select } from "antd";
import ListTable from "common/ListTable";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  EXPORT_BOM_ENDPOINT,
  GET_BOM_ENDPOINT_LIST,
  UPLOAD_FOC_BOM
} from "../../apiServices/API_ENDPOINTS";
import { getData } from "../../apiServices/common";
import {
  BOM_CREATE_PERMISSION,
  BOM_EDIT_PERMISSION,
  BOM_EXPORT_PERMISSION,
  BOM_VIEW_PERMISSION,
} from "../../routes/permissions";
import { hasPermission } from "../../utils/functions";
import { isMobileView } from "../Common/AppHelper";
import CustomFilter from "../Common/CustomFilter";
import Header from "../Common/Header";

const BOM = (props) => {
  // Props
  const { width } = props;

  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [permitList, setPermitList] = useState();
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rangeData, setRangeData] = useState();

  // Others
  const filterData = useSelector(({ filter }) => filter.filterData);

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  // const onExportBOM = async (bom_id) => {
  //   const bodyData = {
  //     id: bom_id,
  //   };

  //   let response = await getData(EXPORT_BOM_ENDPOINT, false, bodyData);

  //   if (response && response?.status === 200) {
  //     const outputFilename = `bom.csv`;

  //     // If you want to download file automatically using link attribute.
  //     const url = URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", outputFilename);
  //     document.body.appendChild(link);
  //     link.click();
  //   } else {
  //     message.error("Error exporting BOM");
  //   }
  // };

  const columns = [
    {
      title: "Buying Office Name",
      dataIndex: ["buying_office_info", "name"],
      key: "buying_office_name",
    },
    {
      title: "Buyer Name",
      dataIndex: ["buyer_info", "name"],
      key: "buyer_name",
    },
    {
      title: "Brand Name",
      dataIndex: ["brand_info", "name"],
      key: "brand_name",
    },
    {
      title: "Factory Name",
      dataIndex: ["sub_contract_factory", "name"],
      key: "factory_name",
    },
    {
      title: "Sales Contract/Sub-Contract Agg.",
      dataIndex: ["sales_contract_info", "reference_no"],
      key: "reference_no",
    },
    {
      title: "Style Number",
      dataIndex: ["style_info", "style_no"],
      key: "style_no",
    },
    {
      title: "Actions",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <div className="cursore-pointer">
          <Dropdown overlay={menu(record)}>
            <MoreOutlined style={{ fontSize: "20px" }} />
          </Dropdown>
        </div>
      ),
    },
  ];

  const getAllPermitList = useCallback(
    async (passedObject) => {
      setLoading(true);

      const filter = passedObject;
      const pageQuery = `${filter?.page ? "" : `?page=${currentPage}`}`;
      const customQuery = `${GET_BOM_ENDPOINT_LIST}/${pageQuery}`;
      const res = await getData(customQuery, false, filter);

      if (res) {
        let masterData = res?.data;
        setPermitList(masterData?.data?.data);
        setTotalData(masterData?.data?.total);
        setRangeData(masterData?.data?.per_page);
      }
      setLoading(false);
    },
    [currentPage],
  );

  useEffect(() => {
    // Get BOM list on first render and on page change
    getAllPermitList(filterData);
  }, [currentPage, getAllPermitList, filterData]);

  const menu = (data) => {
    return (
      <Menu
        items={[
          {
            label: (
              <Link to={`/merchandising/update-BOM/${data.id}`}>
                <EditOutlined /> Edit
              </Link>
            ),
            key: "0",
            disabled: !hasPermission([BOM_EDIT_PERMISSION]),
          },
          {
            label: (
              <Link to={`/merchandising/view-BOM/${data.id}`}>
                <EyeOutlined /> View
              </Link>
            ),
            key: "1",
            disabled: !hasPermission([BOM_VIEW_PERMISSION]),
          },
          {
            label: (
              <Link to={`/merchandising/preview-BOM/${data.id}`}>
                <EyeOutlined /> Export Preview
              </Link>
            ),
            key: "2",
            disabled: !hasPermission([BOM_VIEW_PERMISSION]), // Adjust permission if needed
          },
          // {
          //   label: (
          //     <span onClick={() => onExportBOM(data?.id)}>
          //       <ExportOutlined /> Export
          //     </span>
          //   ),
          //   key: "3",
          //   disabled: !hasPermission([BOM_EXPORT_PERMISSION]),
          // },
        ]}
      />
    );
  };

  const paginate = (page) => {
    setCurrentPage(page);
  };

  const handleFilter = () => {
    setShowFilter((prev) => !prev);
  };


  
    // ✅ File Upload Function (No changes needed here)
    const uploadFile = async (file) => {
      if (!file) return;
      setLoading(true);
  
      const URL = process.env.REACT_APP_BASE_URL + UPLOAD_FOC_BOM;
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("csv_file", file);
  
      try {
        const response = await fetch(URL, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
  
        const contentType = response.headers.get("content-type");
        if (
          contentType &&
          (contentType.includes("application/vnd.ms-excel") ||
            contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))
        ) {
          // ... file download logic (omitted for brevity)
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          const filename =
            response.headers.get("content-disposition")?.split("filename=")[1] ||
            "download.xlsx";
          a.download = filename.replace(/"/g, ''); // Clean up quotes
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          message.success("File downloaded successfully");
        } else {
          const result = await response.json();
          if (response.ok && result.code === 200) {
            message.success("File uploaded successfully");
          } else {
            message.error(result.message || "Error uploading file!");
          }
        }
      } catch (error) {
        message.error(error.message || "Upload failed!");
      } finally {
        setLoading(false);
      }
    };
  const extra = (
    <Space>
      <Button
        type={showFilter ? "danger" : "primary"}
        size="small"
        onClick={() => setShowFilter((prev) => !prev)}
        style={{ float: "right" }}
      >
        {`${showFilter ? "Close" : "Open"} Filter Option`}
      </Button>
      <Button
        key="3"
        size="small"
        type="primary"
        disabled={!hasPermission([BOM_CREATE_PERMISSION])}
      >
        <Link to="/merchandising/add-BOM">
          {hasPermission([BOM_CREATE_PERMISSION]) ? "Add New" : "No Permission"}
        </Link>
      </Button>
            {/* File Upload (FIXED) */}
              {/* Use the colon={false} prop to remove the default label spacing if no label is used, 
                  and use style={{ marginTop: '30px' }} to vertically align it with the small size Selects 
                  by pushing it down by the height of the label + vertical margin/padding. */}
        <Form.Item colon={false} style={{ marginTop: '12px' }}>
          <input
            type="file"
            id="file-input-bom" // Changed ID to avoid potential conflicts
            hidden
            accept=".csv"
            onChange={(e) => uploadFile(e.target.files[0])}
            // Clear the input value after selection to allow re-uploading the same file
            onClick={(e) => { e.target.value = null }} 
        />
        <Button
          type="primary"
          size="small"
          loading={loading}
          icon={loading ? <LoadingOutlined /> : <UploadOutlined />}
          onClick={() => document.getElementById("file-input-bom").click()}
        >
          Upload BOM
        </Button>
        {/* OPTIONAL: Show the selected file name if needed */}
        {/* {!loading && selectedFile && <span style={{ marginLeft: '8px' }}>{selectedFile.name}</span>} */}
      </Form.Item>
    </Space>
  );

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        tableData={permitList}
        fetchTableData={getAllPermitList}
        filterName="bom"
      />
    ),
    [showFilter],
  );

  return (
    <Fragment>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header title="Bill Of Materials" subTitle="" actions={extra} />
        </Card>
      </Affix>

      <div className="containt-body">
        <Card>
          {memoizedCustomFilter}
          <ListTable
            loading={loading}
            dataSource={permitList}
            columns={columns}
            pagination={{
              showSizeChanger: false,
              current: currentPage,
              total: totalData,
              pageSize: rangeData,
              onChange: (page) => paginate(page),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>
    </Fragment>
  );
};

export default BOM;
